// import {currentCart} from '@netx/core-cart/singletons/currentCart';

export const currentCartHasMultipleItems = () =>
	Netx.cart.current.getTotal() > 1;

export default currentCartHasMultipleItems;
